import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./DetailsModal.css";
import { FaRegWindowClose, FaGithub } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";

const DetailsModal = (props) => {
  const { showValue } = props;
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div style={{ backgroundColor: "#f8fdfd" }} className="modal-body-block">
        <Modal.Body className="modal-body">
          <span
            onClick={props.onHide}
            className="close-btn d-flex justify-content-end"
          >
            <FaRegWindowClose className="close-icon" />
          </span>
          <h1 className="text-black"> {showValue.title}</h1>

          <div className="details">
            <h3>Project Summery: </h3>
            {showValue.details1 && <p>1. {showValue.details1}</p>}
            {showValue.details2 && <p>2. {showValue.details2}</p>}
            {showValue.details3 && <p>3. {showValue.details3}</p>}
            {showValue.details4 && <p>4. {showValue.details4}</p>}
            {showValue.details5 && <p>5. {showValue.details5}</p>}
            {showValue.details6 && <p>6. {showValue.details6}</p>}
          </div>

          <div className="project-site-block d-flex justify-content-start flex-column">
            <h5>Live Site :</h5>
            <div className="live-view d-flex justify-content-between">
              {showValue.live && (
                <span className="site-style">
                  <a href={showValue.live}>Client Site</a>
                </span>
              )}
              {showValue.server && (
                <span className="site-style">
                  <a href={showValue.server}>Server Site</a>
                </span>
              )}
            </div>
            <h5 className="mt-3">See Codes :</h5>
            <div className="code-view d-flex justify-content-between">
              {showValue.git_client && (
                <span className="site-style-code">
                  <a href={showValue.git_client}>Client Site</a>
                </span>
              )}
              {showValue.git_server && (
                <span className="site-style-code">
                  <a href={showValue.git_server}>Server Site</a>
                </span>
              )}
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default DetailsModal;
